import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { IPublicRestaurant } from '@localina/core';
import { Page } from '../../components';
import { Path } from '../../enums';
import { IApplicationStore } from '../../interfaces';

interface IStoreProps {
    restaurant?: IPublicRestaurant;
    isLoading: boolean;
}

type IProps = IStoreProps;

const Start: React.FC<IProps> = (props) => {
    const navigate = useNavigate();

    React.useEffect(() => {
        if (props.restaurant) {
            navigate(Path.RESERVATION);
        }
    }, [props.restaurant]);

    return <Page name="start" isLoading={props.isLoading} restaurant={props.restaurant} />;
};

const mapStateToProps = (state: IApplicationStore): IStoreProps => ({
    restaurant: state.restaurant.configuration,
    isLoading: state.restaurant.isLoading,
});

export default connect(mapStateToProps)(Start);
